export default __webpack_public_path__ + "app/images/a7822e6be6aa24ba3c2b5e5794d12694.svg";